import script from "./NotificationMessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessageList.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessageList.vue?vue&type=style&index=0&id=4ba2d0a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba2d0a1"]])

export default __exports__